import { motion } from 'framer-motion';
import { Film } from 'lucide-react';
import { LABELS } from '../../../data/labels';
import { useTraktData } from '../../../hooks/useTraktData';
import { TraktProfileCard } from './TraktProfileCard';
import { NowWatchingCard } from './NowWatchingCard';
import { TopRatedMoviesCard } from './TopRatedMoviesCard';
import { RecentlyWatchedCard } from './RecentlyWatchedCard';

export const CinemaSection = ({ labels }: { labels: typeof LABELS['fr'] }) => {
  const { user, stats, topMovies, currentlyWatching, recentMovies, recentEpisodes, loading, configured, usingMockData } = useTraktData();

  return (
    <div>
      <h2 className="section-title mb-6">
        <Film className="w-6 h-6 text-[#ed1c24]" />
        {labels.cinema_title}
      </h2>

      {(!configured || usingMockData) && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-6 p-4 bg-amber-50 border border-amber-200 rounded-lg"
        >
          <div className="flex items-start gap-3">
            <div className="p-2 bg-amber-100 rounded-lg">
              <span className="text-amber-600 text-lg">⚠️</span>
            </div>
            <div>
              <h4 className="font-medium text-amber-800">{labels.configure_trakt}</h4>
              <p className="text-sm text-amber-700 mt-1">
                {labels.trakt_config_help}
              </p>
              <code className="mt-2 block text-xs bg-amber-100 p-2 rounded text-amber-800">
                TRAKT_CLIENT_ID=votre_client_id<br/>
                TMDB_API_KEY=votre_api_key<br/>
                VITE_TRAKT_USERNAME=votre_nom_utilisateur
              </code>
            </div>
          </div>
        </motion.div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Profil Trakt */}
        <TraktProfileCard
          user={user}
          stats={stats}
          loading={loading}
          labels={labels}
        />

        {/* En cours de visionnage */}
        <NowWatchingCard
          watching={currentlyWatching}
          loading={loading}
          labels={labels}
        />

        {/* Films les mieux notés - prend toute la largeur */}
        <div className="lg:col-span-2">
          <TopRatedMoviesCard
            movies={topMovies}
            loading={loading}
            labels={labels}
          />
        </div>

        {/* Récemment regardé - prend toute la largeur */}
        <div className="lg:col-span-2">
          <RecentlyWatchedCard
            movies={recentMovies}
            episodes={recentEpisodes}
            loading={loading}
            labels={labels}
          />
        </div>
      </div>
    </div>
  );
};
